import { render, staticRenderFns } from "./AskForContent.vue?vue&type=template&id=387e5304&scoped=true"
import script from "./AskForContent.vue?vue&type=script&lang=js"
export * from "./AskForContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e5304",
  null
  
)

export default component.exports